export const defaultPagination = {
    position: ['right'],
    defaultCurrent: 1,
    defaultPageSize: 10,
    showSizeChanger: true,
    showTotal: (total, range) => `Mostrando ${range[0]}-${range[1]} de ${total} registros`,
    pageSizeOptions: ['10', '20', '30', '50', '100']
} 
export const COLOR_LAYOUT = process.env.REACT_APP_COLOR_LAYOUT || "#001529";

export const defaultColorPrimary = "#095253"
export const colorCONALEP = "#007E60"


export const defaultTheme = {
    components: {
        Layout: {
            headerBg: COLOR_LAYOUT,
            siderBg: "#FFFFFF", 
            triggerBg: "#eee",
            triggerColor: "#000000"
        },
        Menu: {
            itemBg: "#FFFFFF",
            itemColor: "#000", 
            //itemSelectedBg: "rgb(0, 79, 80)",
            itemSelectedColor: "#000", 
            //itemHoverBg: "rgb(0, 79, 80)",
            itemHoverColor: COLOR_LAYOUT, 
        },
        Modal: {
            colorBgMask: "#0952536e",
            titleColor: "rgb(0, 79, 80)",
        },
        Table: {
            headerBg: colorCONALEP,
            headerSortHoverBg: colorCONALEP,
            headerSortActiveBg: colorCONALEP,
            headerColor: "#FFFFFF",
        },
        Card: {
            colorTextHeading: "rgba(255, 255, 255, 0.88)",
            headerBg: colorCONALEP
        }
    },
    token: {
        colorPrimary: defaultColorPrimary,
    },
};

export const defaultThemeTabs = {
    components: {
        Tabs: {
            inkBarColor: "#00B3A8",
            itemSelectedColor: "#FFFFFF",
            itemHoverColor: "black",
            itemColor: "black",
            color: "#FFFFFF",
            cardBg: "#D9D9D9",
            colorBgContainer: colorCONALEP
        }
    }
} 